var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", sm5: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "center" } },
              [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.handleBusqueda }
                })
              ],
              1
            )
          ]),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm6: "",
                md4: _vm.accionCrear.visible,
                md6: !_vm.accionCrear.visible
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "15px" },
                  attrs: { align: "right" }
                },
                [
                  _c("ExportarAgGridButton", {
                    attrs: {
                      permisoAccion: _vm.accionExportar,
                      "column-defs": _vm.enrichedGridOptions
                        ? _vm.enrichedGridOptions.columnDefs
                        : _vm.gridOptions.columnDefs,
                      "row-data": _vm.lstCertificadoBase,
                      "exported-file-name": "Certificados"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c("CrearButton", {
                    attrs: { permisoAccion: _vm.accionCrear },
                    on: { click: _vm.handleCrearClick }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          funcionalidadId: _vm.funcionalidad
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "el Certificado"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c("CrearCertificadoModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("VerCertificadoModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          lstCertificadoBase: _vm.lstCertificadoBase,
          certificadoSeleccionado: _vm.certificadoSeleccionado
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("EditarCertificadoModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          lstCertificadoBase: _vm.lstCertificadoBase,
          certificadoSeleccionado: _vm.certificadoSeleccionado
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }